import { Button } from 'libs/ui';
import { Control } from './control.styled';

export const SimpleControl = (props) => {
  const { onChange, content, title } = props;

  const insert = () => {
    const out = content;
    onChange(out);
  };

  return (
    <Control>
      <Button size="small" $alignRight onClick={insert}>
        <span>{title}</span>
        <b>&raquo;</b>
      </Button>
    </Control>
  );
};
